var modal = {
  "adapter-loader.message": "Verify your {{adapter}} account to continue",
  "adapter-loader.message1": "Verify your {{adapter}}",
  "adapter-loader.message2": "account to continue",
  allChains: "All Chains",
  "connect-wallet.more-wallets": "More Wallets",
  connectYourWallet: "Connect your wallet",
  "errors-invalid-email": "Invalid Email",
  "errors-invalid-number": "Invalid Phone Number",
  "errors-invalid-number-email": "Invalid Email or Phone Number",
  "errors-required": "Required",
  "external.all-wallets": "All Wallets",
  "external.back": "Back",
  "external.connect": "Continue with a wallet",
  "external.connect-wallet": "Connect Wallet",
  "external.continue": "Continue with external wallet",
  "external.continue-custom": "Continue with {{wallet}}",
  "external.dont-have": "Don't have",
  "external.get": "Get",
  "external.get-wallet": "Get Wallet",
  "external.install-browser-extension": "Install {{browser}} extension",
  "external.install-mobile-app": "Install {{os}} app",
  "external.installed": "Installed",
  "external.no-wallets-found": "No wallets found",
  "external.search-subtext": "Try search instead",
  "external.search-text": "Don't see your wallet?",
  "external.search-wallet": "Search through {{count}} wallets...",
  "external.select-chain": "Select Chain",
  "external.select-chain-description": "This {{wallet}} wallet supports multiple chains. Select which chain you'd like to connect to",
  "external.title": "External Wallet",
  "external.walletconnect-connect": "Connect",
  "external.walletconnect-copy": "Scan the QR code with WalletConnect supported wallet or click to copy link",
  "external.walletconnect-subtitle": "Scan the QR code with a WalletConnect-compatible wallet",
  "footer.and": "and",
  "footer.by-signing-in": "By signing in, you agree to our",
  "footer.message": "Self-custodial login by",
  "footer.message-new": "Self-custody via",
  "footer.policy": "Privacy Policy",
  "footer.privacy-policy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.terms-of-service": "Terms of Service",
  "footer.terms-service": "Terms of Service",
  "footer.version": "Version",
  getWallet: "Get Wallet",
  "header-subtitle": "Select one of the following options to continue",
  "header-subtitle-name": "Your {{appName}} wallet with one click",
  "header-subtitle-new": "Your blockchain wallet with one click",
  "header-title": "Sign in",
  "header-tooltip-desc": "The wallet serves as an account to store and manage your digital assets on the blockchain.",
  "header-tooltip-title": "Wallet",
  "network.add-request": "This site is requesting to add a network",
  "network.cancel": "Cancel",
  "network.from": "From",
  "network.proceed": "Proceed",
  "network.switch-request": "This site is requesting to switch networks",
  "network.to": "To",
  "otp.email-subtext": "Please enter the 6-digit verification code",
  "otp.email-subtext-example": "that was sent to your email {{email}}",
  "otp.email-title": "Email verification",
  "otp.mobile-subtext": "Enter the OTP sent to",
  "otp.mobile-title": "OTP verification",
  "otp.success": "You are connected to your account!",
  "passkey.add": "Add Passkey",
  "passkey.haveExisting": "Have an existing passkey?",
  "passkey.learn-more": "Learn more",
  "passkey.or": "or",
  "passkey.register-desc": "With passkeys, you can verify your identity through your face, fingerprint, or security keys.",
  "passkey.register-title": "Register Passkey",
  "passkey.use": "I have a passkey",
  "passwordless.title": "Continue with {{title}}",
  "popup.phone-body": "Your country code will be detected automatically, but if you're using a phone number from a different country, you'll need to enter the correct country code manually.",
  "popup.phone-header": "Phone number and country code",
  "post-loading.connected": "You are connected with your account",
  "post-loading.something-wrong": "Something went wrong!",
  resendCode: "Resend Code",
  resendTimer: " Resend in {{timer}} seconds",
  "social.continue": "Continue with",
  "social.continueCustom": "Continue with {{adapter}}",
  "social.email": "Email",
  "social.email-continue": "Continue with Email",
  "social.email-new": "name@example.com",
  "social.passwordless-cta": "Continue",
  "social.passwordless-login": "Login",
  "social.passwordless-title": "Email/Phone",
  "social.phone": "Phone",
  "social.policy": "We do not store any data related to your social logins.",
  "social.sign-in": "Sign in",
  "social.sms": "Mobile",
  "social.sms-continue": "Continue with Mobile",
  "social.sms-invalid-number": "Invalid phone number",
  "social.sms-placeholder-text": "E.g.:",
  "social.view-less": "View less",
  "social.view-less-socials": "View less socials",
  "social.view-more": "View more",
  "social.view-more-socials": "View more socials"
};
var passwordless = {
  "error-invalid-link": "Invalid verification link or link expired",
  "error-invalid-origin": "Something went wrong, error code: E002",
  "error-invalid-otp": "Invalid OTP, please try again",
  "error-invalid-params": "Missing or Invalid Parameters.",
  "error-max-retry-limit-reached": "You have reached the limit for wrong attempts. Please restart the flow again to complete verification.",
  "error-new-link-generated-heading": "New verification link generated",
  "error-no-mail-generated": "No mail generated. Please initiate the passwordless flow first.",
  "error-no-sms-generated": "No OTP generated. Please initiate the passwordless flow first.",
  "error-otp-expired": "OTP Expired",
  "error-plan-limit-reached": "E411. Limit Reached",
  "error-recaptcha-verification-failed": "Captcha verification failed. Please try again.",
  "error-sending-sms-failed": "There was an error sending an sms. Please try again.",
  "error-invalid-test-account": "Invalid test account",
  "something-wrong-error": "Something went wrong"
};
var en = {
  modal: modal,
  passwordless: passwordless
};

export { en as default, modal, passwordless };
